import moment from 'moment'
import { Component, createRef } from 'react'
import { connect } from 'react-redux'

import { getAnalytics } from '../../actions/analytics'
import CustomHeader from '../../components/ReusableComponents/HeaderTitles'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import RefreshButton from '../../components/ReusableComponents/RefreshButton'
import SmartDatepicker, {
  getRealDateFromRelDate,
  smartDateTypes
} from '../../components/ReusableComponents/SmartDatepicker'
import Toggle from '../../components/ReusableComponents/Toggle/index'
import Help from '../../components/Walkme'
import styles from './Analytics.module.scss'
import LineGraph from './LineGraph'
import Sidebar from './Sidebar/index'

const {
  allSubsidiariesToggle,
  analyticsContainer,
  analyticsHolder,
  datepickerModule,
  graphGroup,
  graphsHolder,
  header,
  refreshButton,
  singleLineGraph,
  titleControls
} = styles

class Acquisition extends Component {
  constructor(props) {
    super(props)
    this.joyrideRef = createRef()
  }

  state = {
    startDate: '',
    endDate: '',
    data: null,
    tooltipVisibility: {
      clickRate: false,
      clicks: false,
      bookings: false
    },
    showingHelp: false,
    lastUpdated: null,
    seeAllSubsidiaries: false,
    seeWholeGroup: false
  }

  handleSwitchAllSubsidiaries = () => {
    this.setState(
      {
        seeAllSubsidiaries: !this.state.seeAllSubsidiaries
      },
      () => this.getData()
    )
  }

  handleSwitchToWholeGroup = () => {
    this.setState(
      {
        seeWholeGroup: !this.state.seeWholeGroup
      },
      () => this.getData()
    )
  }

  getData = async () => {
    this.setState({ data: null })

    const { subsidiaryList, currentHotelId } = this.props
    const { seeAllSubsidiaries, seeWholeGroup } = this.state

    if (subsidiaryList.length > 0) {
      let subsidiaryArray = []

      if (seeAllSubsidiaries) {
        subsidiaryList.forEach(obj => {
          subsidiaryArray.push(obj.subsidiaryId)
        })
      }

      if (seeWholeGroup && !seeAllSubsidiaries) {
        const currentMerchantId = subsidiaryList.find(
          s => s.subsidiaryId === currentHotelId
        ).merchantId

        subsidiaryArray = subsidiaryList
          .filter(s => s.merchantId === currentMerchantId)
          .map(s => s.subsidiaryId)
      }

      if (subsidiaryArray.length === 0) {
        subsidiaryArray.push(currentHotelId)
      }

      this.props.dispatch(
        getAnalytics(
          this.state.startDate.format('YYYY-MM-DD'),
          this.state.endDate.format('YYYY-MM-DD'),
          subsidiaryArray
        )
      )
    }
  }

  handleChangeStartDate = startDate => {
    this.setState({
      startDate: startDate.startOf('day')
    })

    if (this.state.endDate.isBefore(startDate, 'day')) {
      this.setState({
        endDate: startDate.clone().endOf('day').add(7, 'days')
      })
    }
  }

  handleChangeEndDate = endDate => {
    this.setState({
      endDate: endDate.endOf('day')
    })
  }

  handleMouseMove = (a, dataKey) => {
    if (a.activePayload) {
      this.setState({
        activeGraphDate: a.activePayload[0].payload.dateView,
        activePayload: a.activePayload[0].payload
      })

      if (dataKey === a.activePayload[0].dataKey) {
        const tooltipVisibility = {
          clickRate: false,
          clicks: false,
          bookings: false
        }

        tooltipVisibility[dataKey] = true
        this.setState({ tooltipVisibility })
      }
    }
  }

  setInitialDates() {
    const relDate = localStorage.getItem(`analyticsDatepicker-sdp-relative`)
    const startDate = localStorage.getItem(`analyticsDatepicker-sdp-start`)
    const endDate = localStorage.getItem(`analyticsDatepicker-sdp-end`)

    if (relDate) {
      const [relStartDate, relEndDate] = getRealDateFromRelDate(relDate)

      this.setState({
        startDate: relStartDate,
        endDate: relEndDate
      })

      return
    }

    if (startDate && endDate) {
      this.setState({
        startDate: moment(startDate),
        endDate: moment(endDate)
      })

      return
    }

    this.setState({
      startDate: moment().utc().local().subtract(7, 'days').startOf('day'),
      endDate: moment().utc().local().endOf('day')
    })
  }

  componentDidMount() {
    if (this.props.isSubsidiaryPosted) {
      this.setInitialDates()
    }

    if (localStorage.getItem('firstTimeOnAnalytics')) {
      this.setState({
        isNewbie: true
      })

      localStorage.removeItem('firstTimeOnAnalytics')
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { startDate, endDate } = this.state

    if (!(prevState.startDate && prevState.endDate)) {
      this.getData()
      return
    }

    if (this.props.subsidiaryList.length !== prevProps.subsidiaryList.length) {
      this.getData()
      return
    }

    if (
      prevState.startDate.format('MMM-DD') !== startDate.format('MMM-DD') ||
      prevState.endDate.format('MMM-DD') !== endDate.format('MMM-DD')
    ) {
      this.getData()
    }

    if (
      this.props.isSubsidiaryPosted !== prevProps.isSubsidiaryPosted &&
      this.props.isSubsidiaryPosted
    ) {
      this.getData()
    }
  }

  hideTooltip = () => {
    this.setState({
      tooltipVisibility: {
        clickRate: false,
        clicks: false,
        bookings: false
      },
      activeGraphDate: null,
      activePayload: null
    })
  }

  joyrideKey = 42

  render() {
    const {
      startDate,
      endDate,
      tooltipVisibility,
      activePayload,
      isNewbie,
      showingHelp
    } = this.state
    const { analyticsData, demoAnalyticsData, updatedOn, isLoading } = this.props

    const data = isNewbie ? demoAnalyticsData : analyticsData

    if (!isLoading && startDate && endDate) {
      return (
        <>
          <CustomHeader title="Reports overview" width={1180} />
          <div className={analyticsHolder}>
            <div className={header}>
              <div className={titleControls}>
                {this.props.subsidiaryList.length > 1 && (
                  <div className={allSubsidiariesToggle}>
                    {this.props.isInternalAdmin && (
                      <Toggle
                        isGray
                        label="See all hotels"
                        handleChange={this.handleSwitchAllSubsidiaries}
                        checked={this.state.seeAllSubsidiaries}
                      />
                    )}
                    <Toggle
                      isGray
                      label="See whole group"
                      handleChange={this.handleSwitchToWholeGroup}
                      checked={this.state.seeWholeGroup}
                      disabled={this.state.seeAllSubsidiaries}
                    />
                  </div>
                )}
                <RefreshButton
                  updatedOn={updatedOn}
                  handleClick={() => this.getData()}
                  className={refreshButton}
                ></RefreshButton>
                <SmartDatepicker
                  isAlignedRight={true}
                  startDate={startDate}
                  endDate={endDate}
                  onChangeStartDate={this.handleChangeStartDate}
                  onChangeEndDate={this.handleChangeEndDate}
                  isRange={true}
                  className={[datepickerModule, 'analyticsDatepicker'].join(' ')}
                  localstorageName="analyticsDatepicker"
                  smartDates={[smartDateTypes.thisWeek]}
                  showMonths
                  showQuarters
                ></SmartDatepicker>
              </div>
            </div>
            <div className={analyticsContainer}>
              <div className={[graphsHolder, 'graphsHolder'].join(' ')}>
                <div className={graphGroup}>
                  {data && (
                    <>
                      <LineGraph
                        data={data.dailyActivities}
                        className={singleLineGraph}
                        dataKey="clickRateGraph"
                        name="Click rate"
                        renderX={false}
                        color="#4079F5"
                        handleMouseMove={this.handleMouseMove}
                        isTooltipVisible={tooltipVisibility.clickRateGraph}
                        activePayload={activePayload}
                      />
                      <LineGraph
                        data={data.dailyActivities}
                        className={singleLineGraph}
                        dataKey="clicks"
                        name="Clicks"
                        renderX={false}
                        color="#66BB6A"
                        handleMouseMove={this.handleMouseMove}
                        isTooltipVisible={tooltipVisibility.clicks}
                        activePayload={activePayload}
                      />
                      <LineGraph
                        data={data.dailyActivities}
                        className={singleLineGraph}
                        dataKey="bookingsTotal"
                        name="Bookings"
                        color="#EAB71A"
                        handleMouseMove={this.handleMouseMove}
                        isTooltipVisible={tooltipVisibility.bookingsTotal}
                        activePayload={activePayload}
                      />
                    </>
                  )}
                </div>
              </div>
              <Sidebar data={data} />
            </div>
          </div>
        </>
      )
    }

    return <LoadingIndicator />
  }
}

const mapStateToProps = state => ({
  subsidiaryList: state.login.subsidiaryList,
  currentHotelId: state.login.currentHotelId,
  analyticsData: state.autoInvite.analyticsData,
  isLoading: state.autoInvite.isLoading,
  updatedOn: state.autoInvite.updatedOn,
  demoAnalyticsData: state.autoInvite.demoAnalyticsData,
  isSubsidiaryPosted: state.login.isSubsidiaryPosted,
  isInternalAdmin: state.login.isInternalAdmin
})

let walkmeSteps = [
  {
    content: (
      <Help
        title="Welcome to Directful Dashboard"
        content="We'll guide you through how to get started! We highly recommend doing this short demo."
      />
    ),
    placement: 'center',
    target: 'body'
  },
  {
    content: (
      <Help
        title="Analytics"
        content="Bookings, revenue and break down each campaign success rate."
      />
    ),
    target: `.${analyticsHolder}`,
    disableBeacon: true
  },
  {
    content: (
      <Help content="This chart is your daily indicator of metrics such as: number of texts, click rate %, number of clicks and bookings. Hover over each day to see the values and watch as the campaign details change under the chart." />
    ),
    target: '.graphsHolder',
    disableBeacon: true,
    spotlightClicks: true
  },
  {
    content: (
      <Help content="This is the daily campaign efficiency board. See what's working well." />
    ),
    target: '.radialBarGroup',
    disableBeacon: true
  },
  {
    content: <Help content="You can change the date range clicking here" />,
    target: '.analyticsDatepicker',
    disableBeacon: true
  },
  {
    content: (
      <Help content="This is bar are the total stats from the above date range selected. This week, month or day." />
    ),
    target: '.analyticsSidebar',
    disableBeacon: true
  }
]

if (localStorage.getItem('firstTimeOnAnalytics')) {
  walkmeSteps.push({
    target: '.sidebarGuests',
    content: (
      <Help
        title="Next: Guest List"
        content="This icon shows you all of your guests uploaded into the Dashboard."
      />
    ),
    spotlightClicks: true,
    disableBeacon: true,
    hideCloseButton: true
  })
}

export default connect(mapStateToProps)(Acquisition)
